var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.967 4.277 10.491.8l-.063-.051-.03-.016-.04-.022-.04-.013-.036-.01h-.161l-.036.01-.04.013-.04.022-.03.016L9.911.8 6.435 4.277a.41.41 0 0 0 .58.579l2.777-2.777V12.97a.41.41 0 0 0 .819 0V2.08l2.777 2.777a.41.41 0 1 0 .58-.58Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.044 17.068H2.357a1.99 1.99 0 0 1-1.99-1.99V13.79a.41.41 0 0 1 .82 0v1.288c0 .646.526 1.17 1.17 1.17h15.687a1.17 1.17 0 0 0 1.17-1.17V13.79a.41.41 0 0 1 .82 0v1.288c0 1.097-.893 1.99-1.99 1.99",
    clipRule: "evenodd"
  })));
};
export { SvgUpload as ReactComponent };
export default __webpack_public_path__ + "upload.06ed9a00246db146d8151e21d2490b46.svg";